import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";

import ManageLogin from "@/views/manage/Login.vue";
import Manage from "@/views/manage/Manage.vue";

const routes = [
  {
    path: "/login",
    name: "管理者平台登入",
    component: ManageLogin,
    meta: { title: "登入 | Quarter Car Part.管理者平台" }
  },
  {
    path: "/",
    component: Manage,
    redirect: {
      name: "廠商帳號管理"
    },
    children: [
      {
        path: "",
        meta: { title: "Quarter Car Part.管理者平台" },
        redirect: {
          name: "廠商帳號管理"
        }
      },
      {
        path: "vendor",
        name: "廠商帳號管理",
        component: () => import("@/components/manage/Vendor.vue"),
        meta: { title: "廠商帳號管理 | Quarter Car Part.管理者平台" },
        props: route => ({ search: route.query.search })
      },
      {
        path: "member",
        name: "會員列表",
        component: () => import("@/components/manage/Member.vue"),
        meta: { title: "會員列表 | Quarter Car Part.管理者平台" },
        props: route => ({ search: route.query.search })
      },
      {
        path: "category",
        component: () => import("@/components/manage/Category.vue"),
        children: [
          {
            path: "",
            meta: { title: "分類管理 | Quarter Car Part.管理者平台" },
            redirect: {
              name: "汽車品牌"
            }
          },
          {
            path: "style",
            name: "汽車品牌",
            meta: { title: "汽車品牌 | Quarter Car Part.管理者平台" },
            component: () => import("@/components/manage/CategoryStyle.vue")
          },
          {
            path: "part-brand",
            name: "零件品牌",
            meta: { title: "零件分類 | Quarter Car Part.管理者平台" },
            component: () => import("@/components/manage/CategoryPartBrand.vue")
          },
          {
            path: "part",
            name: "零件分類",
            meta: { title: "零件分類 | Quarter Car Part.管理者平台" },
            component: () => import("@/components/manage/CategoryPart.vue")
          }
        ]
      },
      {
        path: "shopping-note",
        name: "購物須知",
        meta: { title: "購物須知 | Quarter Car Part.管理者平台" },
        component: () => import("@/components/manage/ShoppingNote.vue")
      },
      {
        path: "report",
        name: "報表",
        meta: { title: "報表 | Quarter Car Part.管理者平台" }
        // component: () => import("@/components/manage/ShoppingNote.vue")
      },
      {
        path: "*",
        name: "該頁無法顯示",
        component: () => import("@/components/NotFoundComponent.vue"),
        meta: { title: "404 Error | Quarter Car Part.管理者平台" }
      }
    ]
  }
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base:
    process.env.BASE_URL +
    (process.env.NODE_ENV === "development" ? "manage/" : ""),
  routes
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.beforeEach(async (to, from, next) => {
  const manageToken = localStorage.getItem("manage-api_token");
  const hasLogin = !!manageToken && manageToken != "undefined";
  window.document.title = to.meta.title;
  if (to.path == "/login") {
    if (hasLogin) {
      next({ name: "廠商帳號管理" });
    } else {
      next();
    }
  } else {
    if (hasLogin) {
      next();
    } else {
      next({ name: "管理者平台登入" });
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

router.onError(error => {
  if (/Loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});
export default router;
